import React from 'react';
import { Button } from '../../../components/ui/button';
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle,
} from '../../../components/ui/dialog';

export const DeleteClientDialog = ({ open, onOpenChange, client, deleting, onConfirm }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle className="text-red-600">Delete Client</DialogTitle>
        <DialogDescription>
          Are you sure you want to delete <strong>{client?.company_name}</strong>?
        </DialogDescription>
      </DialogHeader>
      <div className="py-4">
        <p className="text-sm text-gray-600 mb-4">
          This action will permanently delete:
        </p>
        <ul className="text-sm text-gray-600 list-disc list-inside space-y-1">
          <li>The client account and all contact information</li>
          <li>All orders associated with this client</li>
          <li>All invoices (must be closed/paid first)</li>
          <li>All delivery locations</li>
          <li>The client's portal login account (if any)</li>
        </ul>
        <p className="text-sm text-red-600 mt-4 font-medium">
          This action cannot be undone.
        </p>
      </div>
      <div className="flex justify-end gap-2">
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button
          onClick={onConfirm}
          disabled={deleting}
          className="bg-red-500 hover:bg-red-600 text-white"
        >
          {deleting ? 'Deleting...' : 'Delete Client'}
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
